const state = () => ({
  isValid: false,
  termsConditionsAgreement: false
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  termsConditionsAgreement(state) {
    return state.termsConditionsAgreement;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateTermsConditionsAgreement(state, results) {
    state.termsConditionsAgreement = results;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateTermsConditionsAgreement({ commit }, payload) {
    commit('updateTermsConditionsAgreement', payload);
  }
};

export const forCompaniesTermsConditionsAgreement = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
